/* 設定ファイル一覧

・基本設定:注文締め時間,初期郵便番号等
assets/custom-delivery-datetime-settings.js
・郵便番号と都道府県の対応表
assets/custom-delivery-datetime-postcode-prefs.js
・都道府県とリードタイムの対応表
assets/custom-delivery-datetime-leadtimes.js
・大型商品のリードタイム
assets/custom-delivery-datetime-large-size-leadtimes.js
・企業の休業日 お盆や年末年始（国民の休日以外）
assets/custom-delivery-datetime-company-holidays.js
・郵便番号と離島の対応表
assets/custom-delivery-datetime-remote-islands.js
・表示メッセージの設定表
assets/custom-delivery-datetime-messages.js
・表示画像のURL設定表
assets/custom-delivery-datetime-images.js

*/
if (typeof window.CustomDeliveryDatetime === 'undefined') {
    window.CustomDeliveryDatetime = {};
}

window.CustomDeliveryDatetime = {
    settings: {
        ORDER_THRESHOLD_HOUR: 13,//締め時間
        SPECIAL_MAKER_LEAD_TIME:7,//◎メーカー特別リードタイム
        INITIAL_POSTCODE:"0000000",//初期郵便番号
        LEAD_TIME_MAX: 60,
        PREFS:{},
        POSTCODE_PREFS:[],
        REMOTE_ISLANDS:[],
        LEAD_TIMES:{NORMAL:{},KANTO:{},KYUSHU:{},KANTO_KYUSHU:{}},
        LARGE_SIZE_LEAD_TIMES:{},
        COMPANY_HOLIDAYS:[],
        MESSAGES:{},
        PRODUCT_IMAGES:{},
        CART_IMAGES:{},
    },
    constants: {
        STORAGE_KEY:"CURRENT_POSTCODE_KEY",
        WAREHOUSES : Object.freeze({
          NORMAL:"NORMAL",
          KANTO:"KANTO",
          KYUSHU:"KYUSHU",
          KANTO_KYUSHU:"KANTO_KYUSHU",
        }),
        //商品区分
        PRODUCTTYPES : Object.freeze({
          NORMAL:"NORMAL",
          NORMAL_KANTO:"NORMAL_KANTO",
          NORMAL_KYUSHU:"NORMAL_KYUSHU",
          NORMAL_KANTO_KYUSHU:"NORMAL_KANTO_KYUSHU",
          LARGE:"LARGE",
          LARGE_SHIPPING:"LARGE_SHIPPING",
          LARGE_DELIVERY:"LARGE_DELIVERY",
          MAKER:"MAKER",
          MAKER_DIRECT:"MAKER_DIRECT",
          RESERVATION:"RESERVATION",
          OUT_OF_STOCK:"OUT_OF_STOCK",
          FIXED_SHIPPING_DATE:"FIXED_SHIPPING_DATE",
        }),
        PAGETYPES : Object.freeze({
          PRODUCT:"PRODUCT",
          CART:"CART"
        }),
    },
    result: {shortestDeliveryDate:null,productType:null,remoteIsland:false},
    //国民の休日セット用キャッシュ変数 
    japaneseHolidays:[],
    //郵便番号名称保存用キャッシュ変数
    postCodeNames:{},
    // 郵便番号をブラウザに記憶する
    setPostCode:function(postCode){
        localStorage.setItem(this.constants.STORAGE_KEY,postCode);
    },
    // ブラウザに記録されている郵便番号を取得する
    getPostCode : function(){
        const currentPostCode = localStorage.getItem(this.constants.STORAGE_KEY);
        if(currentPostCode){
            return currentPostCode;
        }
        localStorage.setItem(this.constants.STORAGE_KEY,this.settings.INITIAL_POSTCODE);
        return this.settings.INITIAL_POSTCODE;
    },
    //日付データを「月日」にフォーマットする
    formatDateToJapaneseMonthDate : function(date){
        if(!date)return null;
        const yyyy = date.getFullYear();
        const mm = date.getMonth() + 1;  // 月は0から始まるので+1する
        const dd = date.getDate();    
        return `${mm}月${dd}日`;
    },
    formatPostcode : function(code){
      if(!code)return null;
      if (/^\d{7}$/.test(code)) {
        return code.slice(0, 3) + '-' + code.slice(3);
    }
    // 元の形式をそのまま返す
    return code;
  },

    addDays: function(date, days) {
      const newDate = new Date(date.getTime());
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    },
    // YYYY-MM-DD形式の文字列に変換
    formatDate: function(date){
      return date.toISOString().substring(0,10);
    },
    // 文字列のマッチング
    checkMatchString : function(title,pattern){
      const patternExp = new RegExp(pattern, "g");
      const match = title.match(patternExp);
      if(match)
        return true;
      return false;
    },
    //singleton的に実装
    getJapaneseHolidays: async function(){
      if(this.japaneseHolidays.length > 0){
        return this.japaneseHolidays;
      }
      const url = 'https://holidays-jp.github.io/api/v1/date.json';
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        this.japaneseHolidays = Object.keys(data);
        return this.japaneseHolidays;
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error.message);
      }
      return null;
    },
    isCompanyHoliday: function(date){
      const dateString = this.formatDate(date);
      const companyHolidays = this.settings.COMPANY_HOLIDAYS;
      if(companyHolidays.includes(dateString)){
        return true;
      }
      return false;
    },
    // 土日、祝日、会社休業日かのチェック
    isHoliday: async function(date){
      // 土曜または日曜かどうかを判断
      const dayOfWeek = date.getDay();
      if(dayOfWeek === 0 || dayOfWeek === 6) {
          return true;
      }
      // YYYY-MM-DD形式の文字列に変換
      const dateString = this.formatDate(date);
      // 祝日かどうかを判断
      const japaneseHolidays = await this.getJapaneseHolidays();
      if(japaneseHolidays.includes(dateString)){
        return true;
      }
      // 会社休業日かどうかを判断
      if(this.isCompanyHoliday(date)){
        return true;
      }
      return false;
    },
    isTodaysOrder: function(date){
      if (date.getHours() >= this.settings.ORDER_THRESHOLD_HOUR) {
        return false;
      }
      return true;
    },
    // しきい値を超えたら、翌日に変更
    getOrderDateByThresholdHour: function(date){
      let tempDate = new Date(date.getTime());
      // 受け取ったdateが13時以降の場合、最初に1日加算
      if (!this.isTodaysOrder(tempDate)) {
        tempDate.setDate(tempDate.getDate() + 1);
      }
      return tempDate;
    },
    getNormalShortestShippingDate: function(date){
      let tempDate = new Date(date.getTime());
      tempDate = this.getOrderDateByThresholdHour(tempDate);
      while (this.isCompanyHoliday(tempDate)) {
        // 翌日に変更
        tempDate.setDate(tempDate.getDate() + 1);
      }
      return tempDate;
    },
    //todo これは使わない。仕様を確認する。
    //getLargeSizeShortestShippingDate: async function(date){
    //  let tempDate = new Date(date.getTime());
    //  tempDate = this.getOrderDateByThresholdHour(tempDate);
    //  let isHolidayValue = this.isHoliday(tempDate);
    //  while (isHolidayValue) {
    //    // 翌日に変更
    //    tempDate.setDate(tempDate.getDate() + 1);
    //    isHolidayValue = this.isHoliday(tempDate);
    //  }
    //  return tempDate;
    //},
    extractLeadtime: function(title){
      const datePattern = /(\d+)営業日/;
      const dateMatch = title.match(datePattern);
      if (!dateMatch) {
        return null;
      }
      const days = parseInt(dateMatch[1], 10);
      if(title.match(/※/)){
        return null;
      }
      if(title.match(/◎/)){
        return days + this.settings.SPECIAL_MAKER_LEAD_TIME;
      }
      return days;

    },

    extractDateAndBusinessDays: function(title, currentDate = new Date()){
      const datePattern = /【予約】(\d+)月(\d+)日より(\d+)営業日以内に出荷予定/;
      // 正規表現を使ってマッチング
      const dateMatch = title.match(datePattern);
      if (!dateMatch) {
        return null;
      }
  
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;  // JavaScriptの月は0から始まるため
  
      // マッチングの結果から日付とN営業日を取得
      let date = null;
      const extractedMonth = parseInt(dateMatch[1], 10);
      
      let yearAdjustment = currentYear;
      if (extractedMonth - currentMonth > 6) {
          yearAdjustment--;
      } else if (currentMonth - extractedMonth > 6) {
          yearAdjustment++;
      }
  
      date = new Date(`${yearAdjustment}-${dateMatch[1]}-${dateMatch[2]}`);
  
      const days = parseInt(dateMatch[3], 10);
  
      return {
          date,
          days
      };
    },
    getProductType : function(title){
      if(this.checkMatchString(title,'1～3営業日') && this.checkMatchString(title,'★'))
        return this.constants.PRODUCTTYPES.NORMAL_KANTO;
      if(this.checkMatchString(title,'1～3営業日') && this.checkMatchString(title,'☆'))
        return this.constants.PRODUCTTYPES.NORMAL_KYUSHU;
      if(this.checkMatchString(title,'1～3営業日') && this.checkMatchString(title,'●●'))
        return this.constants.PRODUCTTYPES.NORMAL_KANTO_KYUSHU;
      if(this.checkMatchString(title,'1～3営業日'))
        return this.constants.PRODUCTTYPES.NORMAL;
      if(this.checkMatchString(title,'超大型商品'))
        return this.constants.PRODUCTTYPES.LARGE;
      if(this.checkMatchString(title,'超大型配送'))
        return this.constants.PRODUCTTYPES.LARGE_SHIPPING;
      if(this.checkMatchString(title,'超大型配達'))
        return this.constants.PRODUCTTYPES.LARGE_DELIVERY;
      if(this.checkMatchString(title,'メーカー在庫有'))
        return this.constants.PRODUCTTYPES.MAKER;
      if(this.checkMatchString(title,'メーカーより直送'))
        return this.constants.PRODUCTTYPES.MAKER_DIRECT;
      if(this.checkMatchString(title,'※'))
        return this.constants.PRODUCTTYPES.MAKER_DIRECT;
      if(this.checkMatchString(title,'メーカー取り寄せ'))
        return this.constants.PRODUCTTYPES.MAKER_DIRECT;
      if(this.checkMatchString(title,'在庫無し'))
        return this.constants.PRODUCTTYPES.OUT_OF_STOCK;
      //RegExpを利用する場合はスラッシュ２つ
      if(this.checkMatchString(title,'【予約】(\\d+)月(\\d+)日より(\\d+)営業日以内に出荷予定'))
        return this.constants.PRODUCTTYPES.FIXED_SHIPPING_DATE;

      if(this.checkMatchString(title,'予約'))
        return this.constants.PRODUCTTYPES.RESERVATION;

      // 営業日が含まれている場合はメーカーと判断（既存になぞって）
      if(this.checkMatchString(title,'営業日'))
        return this.constants.PRODUCTTYPES.MAKER;
      return null;
    },
    getPrefId: function(postcode){
      if(!postcode)throw new Error("postcode is null");
      for (const rule of this.settings.POSTCODE_PREFS) {
        if (!postcode.startsWith(rule.PREFIX)) {
          continue;
        }
        return rule.ID;
      }
      return 13;
    },
    checkRemoteIsland: function(postcode){
      return this.settings.REMOTE_ISLANDS.includes(postcode);
    },
    getLeadTime: function(postcode,warehouse = this.constants.WAREHOUSES.NORMAL){
      if(!postcode)throw new Error("postcode is null");
      const prefId = this.getPrefId(postcode);
      //console.log("postcode:",postcode,"prefId:",prefId);
      const leadtime = this.settings.LEAD_TIMES.NORMAL[prefId];
      if(warehouse == this.constants.WAREHOUSES.KANTO 
        || warehouse == this.constants.WAREHOUSES.KYUSHU  
        || warehouse == this.constants.WAREHOUSES.KANTO_KYUSHU
      ){
        const shortenLeadTime = this.settings.LEAD_TIMES[warehouse][prefId];
        if(shortenLeadTime){
          //console.log("leadtime:",leadtime - shortenLeadTime);
          return leadtime - shortenLeadTime;
        }
      }
      //console.log("leadtime:",leadtime);
      return leadtime;
    },
    //　設定からメッセージ取得。文字列でなく辞書型の場合は、都道府県IDをキーにして取得する 
    getMessage: function(productType,remoteIsland){
      if(remoteIsland){
        return this.settings.MESSAGES["REMOTE_ISLAND"];
      }
      let prefId;
      if(productType==this.constants.PRODUCTTYPES.NORMAL){
        prefId = this.getPrefId(this.getPostCode());
      }
      let message = this.settings.MESSAGES[productType];
      if(prefId && typeof message != "string" && typeof message =="object"){
        message = message[prefId];
      }
      return message;
    },
    //　設定からメッセージ取得。文字列でなく辞書型の場合は、都道府県IDをキーにして取得する 
    getImage: function(productType,remoteIsland,pageType){

      const images = (pageType==this.constants.PAGETYPES.PRODUCT) ? this.settings.PRODUCT_IMAGES : this.settings.CART_IMAGES;
      if(remoteIsland){
        return images["REMOTE_ISLAND"];
      }
      let prefId;
      let image = images[productType];
      if(!image && productType==this.constants.PRODUCTTYPES.NORMAL){
        prefId = this.getPrefId(this.getPostCode());
        image = images['NORMAL_REGION'][prefId];
      }
      return image;
    },
    // メインの関数。1バリアントあたりの最短到着日を算出する
    getShortestDeliveryDate: async function(title,postcode,pageType="PRODUCT"){
      if(!postcode)throw new Error("postcode is null");
      if(!title)throw new Error("title is null");

      const productType = this.getProductType(title);
      if(!productType){
        throw new Error("productType is invalid");
      }

      // 離島の場合、最短日は非表示
      let remoteIsland = false;
      if(this.checkRemoteIsland(postcode)){
        remoteIsland = true;
        const message = this.getMessage(productType,remoteIsland);
        const image = this.getImage(productType,remoteIsland,pageType);
          return {productType,shortestDeliveryDate:null,remoteIsland,message,image};  
      }
      const message = this.getMessage(productType);
      const image = this.getImage(productType,remoteIsland,pageType);
      let shortestDeliveryDate = null;
      const today = new Date();
      //通常商品の場合の最短日算出
      if(productType==this.constants.PRODUCTTYPES.NORMAL 
        || productType==this.constants.PRODUCTTYPES.NORMAL_KANTO 
        || productType==this.constants.PRODUCTTYPES.NORMAL_KYUSHU 
        || productType==this.constants.PRODUCTTYPES.NORMAL_KANTO_KYUSHU
      ){
        let warehouse = this.constants.WAREHOUSES.NORMAL;
        if(productType==this.constants.PRODUCTTYPES.NORMAL_KANTO)
          warehouse = this.constants.WAREHOUSES.KANTO;
        if(productType==this.constants.PRODUCTTYPES.NORMAL_KYUSHU)
          warehouse = this.constants.WAREHOUSES.KYUSHU;
        if(productType==this.constants.PRODUCTTYPES.NORMAL_KANTO_KYUSHU)
          warehouse = this.constants.WAREHOUSES.KANTO_KYUSHU;
        const leadTime = this.getLeadTime(postcode,warehouse);
        const orderDate = this.getNormalShortestShippingDate(today);
        shortestDeliveryDate = this.addDays(orderDate, leadTime );
      }
      if(productType==this.constants.PRODUCTTYPES.LARGE || productType==this.constants.PRODUCTTYPES.LARGE_SHIPPING || productType==this.constants.PRODUCTTYPES.LARGE_DELIVERY){
        const orderDate = this.getOrderDateByThresholdHour(today);
        const leadTimeData = this.settings.LARGE_SIZE_LEAD_TIMES[productType];
        const leadTime = await this.isHoliday(orderDate)?leadTimeData.HOLIDAYS:leadTimeData.WEEKDAYS;
        shortestDeliveryDate = this.addDays(orderDate, leadTime );
      }
      if(productType==this.constants.PRODUCTTYPES.MAKER){
        const orderDate = this.getOrderDateByThresholdHour(today);
        const leadTime = this.extractLeadtime(title);
        shortestDeliveryDate = this.addDays(orderDate, leadTime );
      }
      if(productType==this.constants.PRODUCTTYPES.FIXED_SHIPPING_DATE){
        const { date,days } = this.extractDateAndBusinessDays(title);
        shortestDeliveryDate = this.addDays(date, days + 1 );
      }
      return {productType,shortestDeliveryDate,remoteIsland,message,image};
    },

    //単体テスト 納品時はコメントアウト
    unitTest: async function(){
        console.clear();
        console.group('unitTest');
        const todayStr = 'new Date("2023-12-01 10:00:00")';
        const currentPostcode = "2420002";
        let awaitFunctions = [];
        const titles = [
          "■ナチュラル/【在庫有】13時までの注文・決済で1～3営業日出荷",
          "【予約】1月12日より2営業日以内に出荷予定",
          "グレー/【予約】9月中旬（～9月20日までに出荷）",
          "■【E柄】ピンク/【在庫有】3～4営業日以内に出荷[◎土日祝除く]"

          
        ];
        for(title of titles){
          awaitFunctions.push(`CustomDeliveryDatetime.getShortestDeliveryDate("${title}","${currentPostcode}", ${todayStr})`);
        };
        awaitFunctions = [...awaitFunctions,
          'CustomDeliveryDatetime.isHoliday(new Date("2023-10-23"))',
          'CustomDeliveryDatetime.isHoliday(new Date("2023-10-28"))',
          'CustomDeliveryDatetime.isHoliday(new Date("2023-10-29"))',
          'CustomDeliveryDatetime.isHoliday(new Date("2024-01-03"))',
          'CustomDeliveryDatetime.getJapaneseHolidays()'
        ];
        const functions = [
          'CustomDeliveryDatetime.getLeadTime("2420002")',
          'CustomDeliveryDatetime.getLeadTime("2420002",CustomDeliveryDatetime.constants.WAREHOUSES.KANTO)',
          'CustomDeliveryDatetime.isCompanyHoliday(new Date("2023-10-23"))',
          'CustomDeliveryDatetime.isCompanyHoliday(new Date("2023-10-29"))',
          'CustomDeliveryDatetime.isCompanyHoliday(new Date("2024-01-03"))',
          'CustomDeliveryDatetime.getNormalShortestShippingDate(new Date("2023-12-29 09:00:00"))',
          'CustomDeliveryDatetime.getNormalShortestShippingDate(new Date("2023-12-29 13:00:00"))',
          'CustomDeliveryDatetime.getNormalShortestShippingDate(new Date("2023-12-30"))',
          'CustomDeliveryDatetime.getNormalShortestShippingDate(new Date("2023-10-01"))',
          "CustomDeliveryDatetime.getPrefId('1510001')",
          "CustomDeliveryDatetime.getPrefId('2420002')",
          "CustomDeliveryDatetime.getPrefId('0851206')",
          "CustomDeliveryDatetime.getPrefId('8530007')",
          "CustomDeliveryDatetime.getPrefId('9050200')",
          "CustomDeliveryDatetime.getPrefId('5400002')",
          "CustomDeliveryDatetime.getPrefId('0970401')",
          "CustomDeliveryDatetime.checkRemoteIsland('8530007')",
          "CustomDeliveryDatetime.checkRemoteIsland('1510001')",
          "CustomDeliveryDatetime.checkRemoteIsland('0970401')",
          "CustomDeliveryDatetime.getProductType('■ナチュラル/【在庫有】13時までの注文・決済で1～3営業日出荷')",
          "CustomDeliveryDatetime.getProductType('グレー/【予約】9月中旬（～9月20日までに出荷）')",
          "CustomDeliveryDatetime.getProductType('■【E柄】ピンク/【在庫有】3～4営業日以内に出荷[◎土日祝除く]')",
          "CustomDeliveryDatetime.getProductType('【予約】1月12日より2営業日以内に出荷予定')",
          'CustomDeliveryDatetime.extractDateAndBusinessDays("【予約】11月12日より2営業日以内に出荷予定", new Date("2023-10-01"))',
          'CustomDeliveryDatetime.extractDateAndBusinessDays("【予約】1月12日より2営業日以内に出荷予定", new Date("2023-12-01"))',
      ];
        const runCode = (code) => Function(`return async (fetch) => ${code}`)()(fetch)

        const runCodeAndPrint = async (code) => {
          return await runCode(code);
        }
        for(test of functions){
          console.group(test);
          console.log(eval(test));
          console.groupEnd(test);
        }
        for(test of awaitFunctions){
          console.group(test);

          const result = await runCodeAndPrint(test);
          if(Object.prototype.toString.call(result) === '[object Date]'){
            console.log("result:",CustomDeliveryDatetime.formatDate(result));
          }else{
            console.log("result:",result);
          }
          console.groupEnd(test);
        };
        console.groupEnd('unitTest');
    }
    //単体テストここまで

  
}